import {
    changePassword,
    getByUsername,
    pushSubscription,
    resetPassword,
    changeStatusUser,
    lectureByProdi
} from '@/store/api/UserController'
const initialState = () => ({
    old_password: '',
    new_password: '',
    userData: null,
    response: {},
    lectures: []
})
const state = initialState

const getters = {
    getOld_password: state => state.old_password,
    getNew_password: state => state.new_password,
    getResponse: state => state.response,
    getUserData: state => state.userData,
    getLecture: state  => state.lectures
}

const actions = {
    async getLectureData({
        commit
    }, id = null) {
        try {
            const url = '/lectures-prodi' + (id ? `/${id}` : '')
            const response = await lectureByProdi(url);
            commit('SET_LECTURE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async changeStatusUser({
        commit
    }, data) {
        try {
            var response = await changeStatusUser(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async resetPassword({
        commit
    }, data) {
        try {
            var response = await resetPassword(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async changePassword({
        commit
    }, data) {
        try {
            var response = await changePassword(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async pushSubscription({
        commit
    }, data) {
        try {
            var response = await pushSubscription(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getByUsername({
        commit
    }, username) {
        try {
            var response = await getByUsername(username);
            commit('SET_DATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    }
}

const mutations = {
    SET_FAILED(state) {
        state.response = {
            message: 'Jaringan Bermasalah',
            status: 0
        }
    },
    SET_RESPONSE(state, response) {
        state.response = response
    },
    SET_LECTURE(state, response){
        state.lectures = response.data
    },
    SET_DATA(state, response) {
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.userData = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}